/* ============================================================
   TarotCard.module.css — Ecliptica Tarot Card flip & hover
   Adapted from tarot-card.css for use in TarotReadingPage.
   ============================================================ */

.wrap {
  width: 100%;
  height: 100%;
  cursor: pointer;
  perspective: 900px;
  user-select: none;
  -webkit-user-select: none;
  position: relative;
  transition: transform 0.22s ease;
}

.disabled {
  cursor: not-allowed;
}

.inner {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.55s cubic-bezier(0.4, 0, 0.2, 1);
}

.wrap:hover,
.wrap.flipped:hover {
  will-change: transform;
}

.wrap.flipped .inner {
  transform: rotateY(180deg);
}

.face,
.back {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: 12px;
  overflow: hidden;
}

.back {
  transform: rotateY(0deg);
}

.face svg,
.back svg {
  width: 100%;
  height: 100%;
  display: block;
}

.svgFill {
  width: 100%;
  height: 100%;
  display: block;
}

.svgFill svg {
  shape-rendering: geometricPrecision;
  text-rendering: geometricPrecision;
}

.wrap:hover .inner {
  transform: none;
}

.wrap.flipped:hover .inner {
  transform: rotateY(180deg);
}

.wrap:hover {
  transform: translateY(-4px);
}

.hint {
  position: absolute;
  left: 50%;
  top: 14px;
  transform: translateX(-50%);
  font-family: 'DM Mono', monospace;
  font-size: 9px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(62, 207, 202, 0.7);
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  z-index: 3;
}

.reversed {
  transform: rotateY(180deg) rotate(180deg);
  transform-origin: 50% 50%;
}

.face {
  transform: rotateY(180deg);
}
